module.exports = __webpack_public_path__ + "img/wxt2.29877fc5.jpg";